import { BottomSheet as UIBottomSheet, type BottomSheetProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

type Props = Omit<BottomSheetProps, 'closeButtonLabel'>

const BottomSheet = (props: Props) => {
    const { t } = useTranslation()
    return (
        <UIBottomSheet
            {...props}
            closeButtonLabel={t('components.bottomSheet.closeButton')}
        />
    )
}

export default BottomSheet
